import styled from 'styled-components';

import { IS_CLOUD } from '@qality/common-config';

// height calc is due to 2em of margin added to #com_soldevelo_apps_test-management_container
// TODO: remove 2em of margin at the root element
export const AddTestCasesFormPageContainerStyled = styled.div`
  height: ${IS_CLOUD ? 'calc(100vh - 2em)' : 'calc(100vh - 215px)'};
  display: flex;
  flex-direction: column;
`;

export const AddTestCasesStepStyled = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
